import { useContext } from 'react';
import { useStateValue } from "../helpers";
import { DatetimeInputContext } from "../controls/DatetimeInput/DatetimeInputContext";
var shiftMonth = function (currentShownMonth, value) {
    var nextMonthDate = new Date(currentShownMonth.year, currentShownMonth.month + value, 1);
    return {
        year: nextMonthDate.getFullYear(),
        month: nextMonthDate.getMonth()
    };
};
export var useMonthCalendarViewModel = function (_a) {
    var selectedDate = _a.selectedDate, initialShownMonth = _a.initialShownMonth, startDatetime = _a.startDatetime, endDatetime = _a.endDatetime, onSelect = _a.onSelect, isDisabledDate = _a.isDisabledDate, onMonthChange = _a.onMonthChange;
    var _b, _c;
    var now = useContext(DatetimeInputContext).getNowTime();
    if (!initialShownMonth) {
        initialShownMonth = {
            year: (_b = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getFullYear()) !== null && _b !== void 0 ? _b : now.getFullYear(),
            month: (_c = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.getMonth()) !== null && _c !== void 0 ? _c : now.getMonth()
        };
    }
    var shownMonthState = useStateValue(initialShownMonth, [initialShownMonth], {
        onChange: function (nextValue, prevValue) {
            if (nextValue.month !== prevValue.month || nextValue.year !== prevValue.year) {
                onMonthChange === null || onMonthChange === void 0 ? void 0 : onMonthChange(nextValue);
            }
        }
    });
    var shownMonthValue = shownMonthState.getValue();
    var prevMonth = new Date(shownMonthValue.year, shownMonthValue.month, 0);
    var nextMonth = new Date(shownMonthValue.year, shownMonthValue.month + 1, 0);
    var hasPrevMonth = prevMonth >= startDatetime;
    var hasNextMonth = nextMonth <= endDatetime;
    var isDayDisabled = function (day) {
        var ceilDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 23, 59, 59);
        var floorDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0);
        var lessThanStartDatetime = ceilDate < startDatetime;
        var moreThanEndDatetime = floorDate > endDatetime;
        return lessThanStartDatetime || (isDisabledDate === null || isDisabledDate === void 0 ? void 0 : isDisabledDate(day)) || moreThanEndDatetime;
    };
    var onPrevMonthClick = function () {
        var newShownMonth = shiftMonth(shownMonthState.getValue(), -1);
        shownMonthState.setValue(newShownMonth);
    };
    var onNextMonthClick = function () {
        var newShownMonth = shiftMonth(shownMonthState.getValue(), 1);
        shownMonthState.setValue(newShownMonth);
    };
    var onTodaySelect = function () {
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        shownMonthState.setValue({ year: today.getFullYear(), month: today.getMonth() });
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(now);
    };
    return {
        selectedDate: selectedDate,
        shownMonth: shownMonthState.getValue(),
        isDayDisabled: isDayDisabled,
        hasPrevMonth: hasPrevMonth,
        hasNextMonth: hasNextMonth,
        onPrevMonthClick: onPrevMonthClick,
        onNextMonthClick: onNextMonthClick,
        onTodaySelect: onTodaySelect
    };
};
//# sourceMappingURL=hooks.js.map